import { FadeIn } from '~/components/ui/fade-in';

interface TacticalDronesOverviewSectionProps {
  title: string;
  description: string;
}

export const TacticalDronesOverviewSection = ({
  title,
  description,
}: TacticalDronesOverviewSectionProps) => {
  return (
    <section className="relative w-full bg-black px-4 md:px-8 lg:px-20 py-[120px] lg:py-[240px] flex items-center justify-center">
      <div className="flex flex-col gap-10 items-center justify-center w-full max-w-7xl">
        <FadeIn>
          <p className="font-['Fragment_Mono'] text-sm text-white tracking-[0.14px] uppercase">
            {title}
          </p>
        </FadeIn>
        <FadeIn delay={0.15}>
          <div className="flex items-center justify-center w-full">
            <p className="flex-1 font-normal text-[32px] md:text-[56px] leading-normal text-center text-white whitespace-pre-wrap">
              {description}
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};
